module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("grVJp"))).then(() => module.bundle.root('ewmtE'));